import React, { useEffect, useState } from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import axiosInstance from "../../utils/config/config";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";

const PerformanceGraph = ({ creatorId }) => {
  const [data, setData] = useState([]);
  const mediumScreen = useMediaQuery("(max-width:900px)");

  useEffect(() => {
    const fetchTrends = async () => {
      try {
        const res = await axiosInstance.get(`/user/subscriptionTrends`);
        const { userSubscriptions, ppvPurchases } = res.data.trends;
        const combined = mergeMonthlyData(userSubscriptions, ppvPurchases);
        setData(combined);
      } catch (err) {
        console.error("Error fetching subscription trends:", err);
      }
    };

    fetchTrends();
  }, [creatorId]);

  const mergeMonthlyData = (subs, ppvs) => {
    const map = {};
    subs.forEach((item) => {
      if (!map[item.month]) map[item.month] = { month: item.month };
      map[item.month].subscriptions = item.subscriptions;
    });
    ppvs.forEach((item) => {
      if (!map[item.month]) map[item.month] = { month: item.month };
      map[item.month].purchases = item.purchases;
    });
    return Object.values(map).sort(
      (a, b) => new Date(`1 ${a.month} 2023`) - new Date(`1 ${b.month} 2023`)
    );
  };

  return (
    <Box sx={{ mt: 4 }}>
      <Typography
        sx={{
          fontSize: "23px",
          fontFamily: "Inter-SemiBold",
          color: "#000",
          mb: 2,
        }}
      >
        Subscription Trends
      </Typography>

      <Box sx={{ border: "1px solid #000", paddingTop: "50px" }}>
        <ResponsiveContainer width="100%" height={400}>
          <LineChart
            data={data}
            margin={{ top: 20, right: 20, left: -10, bottom: 10 }}
          >
            <XAxis dataKey="month" tick={{ fontSize: 12 }} />
            <YAxis tick={{ fontSize: 12 }} allowDecimals={false} />
            <Tooltip
              contentStyle={{
                backgroundColor: "#FFF",
                borderRadius: "8px",
                fontSize: 12,
              }}
              formatter={(value) => `${value}`}
              labelStyle={{ fontWeight: 600 }}
            />
            <Legend
              wrapperStyle={{
                top: -30,
                left: mediumScreen ? "0%" : "-40%",
                fontSize: 15,
              }}
              iconType="circle"
            />
            <Line
              type="monotone"
              dataKey="subscriptions"
              stroke="#1976D2"
              strokeWidth={2}
              activeDot={{ r: 6 }}
              name="User Subscriptions"
            />
            <Line
              type="monotone"
              dataKey="purchases"
              stroke="#FF5722"
              strokeWidth={2}
              activeDot={{ r: 6 }}
              name="PPV Purchases"
            />
          </LineChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

export default PerformanceGraph;
